import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { focusStyle } from '../styles/mixins';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    stepNumber: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 36,
      height: 36,
      border: `2px solid ${theme.color.greys[40]}`,
      backgroundColor: 'transparent',
      borderRadius: '50%',
      marginRight: 16,
      flexShrink: 0,
    },
    stepNumberInner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 36,
      height: 36,
      borderRadius: '50%',
      position: 'relative',
      zIndex: 1,
      color: theme.color.greys[40],
      [theme.breakpoints.down('sm')]: {
        width: () => 25,
        height: () => 25,
        right: 0,
      },
    },
    stepNumberActive: {
      backgroundColor: theme.color.oranges[50],
      color: theme.color.greys[0],
      borderColor: theme.color.oranges[50],
    },
    textContent: {
      flex: 1,
      width: '100%',
    },
    titleWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      width: '100%',
    },
    itemText: {
      marginTop: 5,
      margin: 0,
      '&:focus-visible': {
        ...focusStyle(theme),
      },
    },
    itemTextSubtitle: {
      marginTop: 4,
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        marginTop: () => 4,
      },
      '&:focus-visible': {
        ...focusStyle(theme),
      },
    },
    actionsWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
  }), { name: 'NumberedStepHeader', index: StylesIndexInjections.UI_MOLECULES });
